<template>
  <div >
    <h1>交易紀錄</h1><!--目前所在頁面標題-->
    <section class="transaction_list">
      <ul>
        <li  v-for = "transactionData in transactionDatas" :key="transactionData.id">
          <TransactionList :transactionData="transactionData"/>
        </li>
      </ul>
    </section>

    <section class="emptyPage" v-if="transactionDatas.length == 0">
      <div class="wrap">
        <figure>
          <img src="@/assets/images/status_empty_transaction.png" alt="沒有任何交易紀錄">
          <figcaption>
            您目前沒有任何紀錄
          </figcaption>
        </figure>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TransactionList from './components/TransactionList'

export default {
  name: 'myTransaction',
  components: { TransactionList },
  metaInfo () {
    return {

      title: '交易紀錄 | 我的 | 一刻鯨選',
      meta: [
        // OpenGraph data (Most widely used)
        { property: 'og:title', content: '交易紀錄 | 我的 | 一刻鯨選' },
        { property: 'og:site_name', content: '交易紀錄 | 我的 | 一刻鯨選' },
        // The list of types is available here: http://ogp.me/#types
        { property: 'og:type', content: 'website' },
        // Should the the same as your canonical link, see below.
        { property: 'og:url', content: window.location.toString() },
        { property: 'og:image', content: this.$store.state.urlDomain + '/static/logo.jpg' },
        // Often the same as your meta description, but not always.
        { property: 'og:description', content: '登入後，即可查看帳戶所有資訊。' }

      ]
    }
  },
  data () {
    return {
      transactionDatas: [],
      coupon: [],

      // 測試用 START
      // addtransactionDatas: [
        //Typr 1 點數兌換
        // {
        //   id: "1fde2747-0b40-47ea-bde5-a54aef618e7",
        //   order_type: 1,
        //   transactionId: "GPA.3307-1317-3528-77001",
        //   payment_type: 2,
        //   points: 30,
        //   orderNumber: "A19011107185953986",
        //   statusCode: 1000,
        //   created_at: "2019-01-11T07:19:19Z"
        // },
        // {
        //   id: "1fde2747-0b40-47ea-bde5-a54af94563456e7",
        //   order_type: 1,
        //   transactionId: "GPA.3307-1317-3528-77001",
        //   payment_type: 2,
        //   points: 30,
        //   orderNumber: "A19011107185953986",
        //   statusCode: 3000,
        //   created_at: "2019-01-11T07:19:19Z"
        // },
        //Typr 2 商品兌換
        // {
        //   channel:{
        //     id: 68,
        //     title: "憂國憂民思想導讀會",
        //     titleCN: "忧国忧民思想导读会"
        //   },
        //   product:{
        //     id: 514675,
        //     productType: 1
        //   },
        //   coupon: null,
        //   area: null,
        //   created_at: "2020-06-11T06:30:44Z",
        //   id: "515",
        //   points: 177,
        //   orderNumber: "B20061106304411512",
        //   order_type: 2,
        //   statusCode: 7000
        // },
        // {
        //   channel:{
        //     id: 68,
        //     title: "憂國憂民思想導讀會",
        //     titleCN: "忧国忧民思想导读会"
        //   },
        //   product:{
        //     id: 45,
        //     productType: 1
        //   },
        //   coupon: null,
        //   area: null,
        //   created_at: "2020-06-11T06:30:44Z",
        //   id: "5685",
        //   points: 177,
        //   orderNumber: "B20061106304411512",
        //   order_type: 2,
        //   statusCode: 5000
        // },
        //Typr 3 贈課紀錄(送)
        // {
        //   channel:{
        //     id: 68,
        //     title: "憂國憂民思想導讀會",
        //     titleCN: "忧国忧民思想导读会"
        //   },
        //   product:{
        //     id: 57815,
        //     productType: 1
        //   },
        //   coupon: null,
        //   area: null,
        //   created_at: "2020-06-11T06:30:44Z",
        //   retreatStatus: false,
        //   retreatDate: null,
        //   id: "578915",
        //   points: 1,
        //   orderNumber: "B20061106304411512",
        //   order_type: 3,
        //   points: 30,
        //   statusCode: 8000
        // },
        // {
        //   channel:{
        //     id: 68,
        //     title: "憂國憂民思想導讀會",
        //     titleCN: "忧国忧民思想导读会"
        //   },
        //   product:{
        //     id: 51685,
        //     productType: 1
        //   },
        //   coupon: null,
        //   area: null,
        //   created_at: "2020-06-11T06:30:44Z",
        //   retreatStatus: false,
        //   retreatDate: null,
        //   id: "506415",
        //   points: 1,
        //   orderNumber: "B20061106304411512",
        //   order_type: 3,
        //   points: 30,
        //   statusCode: 5000
        // },
        //Typr 4 贈課紀錄(收)
        // {
        //   channel:{
        //     id: 68,
        //     title: "憂國憂民思想導讀會",
        //     titleCN: "忧国忧民思想导读会"
        //   },
        //   product:{
        //     id: 162,
        //     productType: 1
        //   },
        //   coupon: null,
        //   area: null,
        //   created_at: "2020-06-11T06:30:44Z",
        //   id: "977d8537-7053-4339-9ba9-beRgg1nlkn",
        //   points: 1,
        //   orderNumber: "B20061106304411512",
        //   order_type: 4,
        //   points: 30,
        //   statusCode: 7000
        // },
        // {
        //   channel:{
        //     id: 68,
        //     title: "憂國憂民思想導讀會",
        //     titleCN: "忧国忧民思想导读会"
        //   },
        //   product:{
        //     id: 162,
        //     productType: 1
        //   },
        //   coupon: null,
        //   area: null,
        //   created_at: "2020-06-11T06:30:44Z",
        //   id: "977d8537-7053-4339-9ba9-beRgg1nlkn",
        //   points: 1,
        //   orderNumber: "B20061106304411512",
        //   order_type: 4,
        //   points: 30,
        //   statusCode: 5000
        // },
        //Typr 5 單集購買
        // {
        //   channel:{
        //     id: 68,
        //     title: "憂國憂民思想導讀會",
        //     titleCN: "忧国忧民思想导读会"
        //   },
        //   product:{
        //     id: 162,
        //     productType: 1,
        //     subscription_text: '月',
        //     episodePoints: 5
        //   },
        //   episodes: [
        //     {
        //       id: "e287922f-0bfe-4a14-95a3-1e69c643c7ca",
        //       title: "第144集-鍥而不捨",
        //       titleCN: "第144集-锲而不舍"
        //     }
        //   ],
        //   coupon: null,
        //   area: null,
        //   created_at: "2020-06-11T06:30:44Z",
        //   id: "977d8537-7053-4339-9ba9-becf3bb1nlkn",
        //   orderNumber: "B20061106304411512",
        //   order_type: 5,
        //   is_discount: true,
        //   points: 30,
        //   statusCode: 7000
        // },
        // {
        //   channel:{
        //     id: 68,
        //     title: "憂國憂民思想導讀會",
        //     titleCN: "忧国忧民思想导读会"
        //   },
        //   product:{
        //     id: 162,
        //     productType: 1,
        //     subscription_text: '月',
        //     episodePoints: 5
        //   },
        //   episodes: [
        //     {
        //       id: "e287922f-0bfe-4a14-95a3-1e69c643c7ca",
        //       title: "第144集-鍥而不捨",
        //       titleCN: "第144集-锲而不舍"
        //     }
        //   ],
        //   coupon: null,
        //   area: null,
        //   created_at: "2020-06-11T06:30:44Z",
        //   id: "977d8537-7053-4339-9ba9-becf3bb1nlkn",
        //   orderNumber: "B20061106304411512",
        //   order_type: 5,
        //   is_discount: true,
        //   points: 30,
        //   statusCode: 5000
        // },
        //Typr 6 點數兌換
        // {
        //   area: {
        //     id: 68,
        //     display_name: '憂國憂民思想導讀會',
        //     display_name_cn: "忧国忧民思想导读会"
        //   },
        //   channel:{
        //     id: 68,
        //     title: "憂國憂民思想導讀會",
        //     titleCN: "忧国忧民思想导读会"
        //   },
        //   coupon:{
        //     id: 309,
        //     number: "CGP6XC2QS5LQ",
        //     points: 0,
        //     title: "贈課",
        //     titleCN: "贈課",
        //     type: 7
        //   },
        //   created_at: "2020-06-11T06:30:44Z",
        //   id: "2718c304-ab1b-4119-8a75-e655SDVsdvDF",
        //   orderNumber: "B20061106304411512",
        //   order_type: 6,
        //   transactionId: "GPA.3307-1317-3453-77001",
        //   is_discount: true,
        //   points: 30,
        //   product:{
        //     id: 162,
        //     productType: 1,
        //     subscription_text: '月'
        //   },
        //   statusCode: 7000
        // },
        // {
        //   area: {
        //     id: 68,
        //     display_name: '路易莎橘色旋風：從一人到五百家店的咖啡創業心路',
        //     display_name_cn: "路易莎橘色旋风：从一人到五百家店的咖啡创业心路"
        //   },
        //   channel:{
        //     id: 68,
        //     title: '路易莎橘色旋風：從一人到五百家店的咖啡創業心路',
        //     titleCN: "路易莎橘色旋风：从一人到五百家店的咖啡创业心路"
        //   },
        //   coupon:{
        //     id: 309,
        //     number: "CGP6XC2QS5LQ",
        //     points: 0,
        //     title: "贈課",
        //     titleCN: "贈課",
        //     type: 7
        //   },
        //   created_at: "2020-06-11T06:30:44Z",
        //   id: "2718c304-ab1b-4119-8a75-eSDVSfvDF",
        //   orderNumber: "B20061106304411512",
        //   order_type: 6,
        //   transactionId: "GPA.3307-1317-3528-7464561",
        //   is_discount: false,
        //   points: 60,
        //   product:{
        //     id: 162,
        //     productType: 1,
        //     subscription_text: '月'
        //   },
        //   statusCode: 7000
        // },
        // {
        //   area: {
        //     id: 68,
        //     display_name: '路易莎橘色旋風：從一人到五百家店的咖啡創業心路',
        //     display_name_cn: "路易莎橘色旋风：从一人到五百家店的咖啡创业心路"
        //   },
        //   channel:{
        //     id: 68,
        //     title: '路易莎橘色旋風：從一人到五百家店的咖啡創業心路',
        //     titleCN: "路易莎橘色旋风：从一人到五百家店的咖啡创业心路"
        //   },
        //   coupon:{
        //     id: 309,
        //     number: "CGP6XC2QS5LQ",
        //     points: 0,
        //     title: "贈課",
        //     titleCN: "贈課",
        //     type: 7
        //   },
        //   created_at: "2020-06-11T06:30:44Z",
        //   id: "2718c304-ab1b-4119-8a75-eSDVSfvDF",
        //   orderNumber: "B20061106304411512",
        //   order_type: 6,
        //   transactionId: "GPA.3307-1317-3528-7464561",
        //   is_discount: false,
        //   points: 60,
        //   product:{
        //     id: 162,
        //     productType: 1,
        //     subscription_text: '月'
        //   },
        //   statusCode: 9000
        // },
        //Typr 7 Google Play Point
        // {
        //   id: "93503250-290c-41d9-a62d-fae4b78b47ed",
        //   order_type: 7,
        //   transactionId: "GPA.3351-8486-7778-42269",
        //   payment_type: 3,
        //   points: 300,
        //   orderNumber: "A210202091348677e3",
        //   statusCode: 1000,
        //   created_at: "2021-02-02T09:13:55Z"
        // },
        // {
        //   id: "93503250-290c-41d9-a62d-fae4b78b345d",
        //   order_type: 7,
        //   transactionId: "GPA.3351-8486-7778-42269",
        //   payment_type: 3,
        //   points: 300,
        //   orderNumber: "A210202091348677e3",
        //   statusCode: 6000,
        //   created_at: "2021-02-02T09:13:55Z"
        // }
      // ]
      // 測試用 END
    }
  },
  filters: {
    pointReset: function (value) {
      return value < 0 ? 0 : value
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created () {
    this.getTransaction()
  },
  methods: {
    convertUTCTimeToLocalTime: function (UTCDateString) {
      if (!UTCDateString) {
        return '-'
      }
      function formatFunc (str) { // 格式化显示
        return str > 9 ? str : '0' + str
      }
      var date2 = new Date(UTCDateString) // 这步是关键
      var year = date2.getFullYear()
      var mon = formatFunc(date2.getMonth() + 1)
      var day = formatFunc(date2.getDate())
      var hour = date2.getHours()
      // var noon = hour >= 12 ? 'PM' : 'AM';
      // hour = hour>=12?hour-12:hour;
      // hour = formatFunc(hour);
      var min = formatFunc(date2.getMinutes())
      var sec = formatFunc(date2.getSeconds())

      var dateStr = year + '-' + mon + '-' + day + ' ' + hour + ':' + min + ':' + sec
      return dateStr
    },
    getTransaction: function () {
      this.axios
        .get(this.$store.getters.baseURL + 'orders', { headers: { Authorization: `Bearer ${localStorage.getItem('credentialToken')}` } })
        .then(response => {
          console.log(response.data)
          this.transactionDatas = response.data
        })
        .catch(error => console.log('log:' + error))
    }
  }
}
</script>

<style>

@import '../../../../assets/css/user.css';
@import '../../../../assets/css/user_rwd.css';
 body {padding-top: 0;}
 /* body {padding-top: 0;}
 .bodyHeader {display: none;} */

@media screen and (min-width: 576px) {
  .status_wrap {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/mySubviews/MyTransactionItem/index.vue